import axios from 'axios';

/**
 * Arşivlenmiş formlar için API servisleri
 */
class ArchivedFormsService {
  constructor() {
    this.baseURL = 'https://app.hhoms.com/api/form';
  }

  /**
   * Ortak headers oluştur
   */
  getHeaders(appToken, userId) {
    return {
      'ApplicationToken': appToken,
      'User': userId,
      'Content-Type': 'application/json'
    };
  }

  /**
   * Arşivlenmiş formları çek
   * @param {string} appToken - Uygulama token'ı
   * @param {string} userId - Kullanıcı ID'si
   * @returns {Promise<Array>} Arşivlenmiş formların listesi
   */
  async fetchArchivedForms(appToken, userId) {
    try {
      let allForms = [];
      
      // Her zaman hem 0 hem de 1 tipini çek (Form ve Tablo)
      const fileTypes = [0, 1];
      
      for (const fileType of fileTypes) {
        const response = await axios.get(
          `${this.baseURL}/Libraries/list/archive/${fileType}`, 
          {
            headers: this.getHeaders(appToken, userId)
          }
        );
        
        const formsWithType = (response.data.formLibraries || []).map(form => ({
          ...form,
          fileType: fileType
        }));
        
        allForms = [...allForms, ...formsWithType];
      }
      
      return allForms;
    } catch (error) {
      console.error('Arşivlenmiş formlar yüklenirken hata:', error);
      throw new Error('Arşivlenmiş formlar yüklenirken bir hata oluştu.');
    }
  }

  /**
   * Formu geri yükle (restore)
   * @param {number} formId - Form ID'si
   * @param {string} appToken - Uygulama token'ı
   * @param {string} userId - Kullanıcı ID'si
   * @returns {Promise} API yanıtı
   */
  async restoreForm(formId, appToken, userId) {
    try {
      const response = await axios.put(
        `${this.baseURL}/Libraries/archive/${formId}/false`,
        {},
        {
          headers: this.getHeaders(appToken, userId)
        }
      );
      
      return response.data;
    } catch (error) {
      console.error('Form geri yüklenirken hata:', error);
      throw new Error('Form geri yüklenirken bir hata oluştu.');
    }
  }

  /**
   * Formu kalıcı olarak sil
   * @param {number} formId - Form ID'si
   * @param {string} appToken - Uygulama token'ı
   * @param {string} userId - Kullanıcı ID'si
   * @returns {Promise} API yanıtı
   */
  async deleteFormPermanently(formId, appToken, userId) {
    try {
      const response = await axios.delete(
        `${this.baseURL}/Libraries/${formId}`,
        {
          headers: this.getHeaders(appToken, userId)
        }
      );
      
      return response.data;
    } catch (error) {
      console.error('Form silinirken hata:', error);
      throw new Error('Form silinirken bir hata oluştu.');
    }
  }
}

// Singleton instance
const archivedFormsService = new ArchivedFormsService();
export default archivedFormsService;
